import * as React from "react";

const SvgWorkbenchTabArrowLeft = props => <svg viewBox="0 0 15 15" style={{
  enableBackground: "new 0 0 15 15"
}} xmlSpace="preserve" width="1em" height="1em" {...props}><path d="M7.5 0C3.4 0 0 3.4 0 7.5S3.4 15 7.5 15 15 11.6 15 7.5 11.6 0 7.5 0zm1.7 9.8c.3.3.3.8 0 1.1-.2.1-.4.2-.6.2s-.4-.1-.5-.2L5.3 8c-.3-.3-.3-.7 0-1l2.8-2.8c.3-.3.8-.3 1.1 0s.3.8 0 1.1L6.9 7.5l2.3 2.3z" className="workbench_tab_arrow_left_svg__st0" /></svg>;

export default SvgWorkbenchTabArrowLeft;